function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgDiners = function SvgDiners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.35,
    cy: 15.85,
    r: 7.85,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.01 12.39c-.117.101-.25.208-.355.32a4.587 4.587 0 00-1.238 3.136 4.592 4.592 0 001.247 3.136c.105.112.227.218.344.32.403.353.769.638 1.33.834-.015-.005-.069-.012-.069-.018v-8.545c0-.006.054-.013.069-.018-.561.196-.925.482-1.328.835zM15.566 11.555c.006.002-.069.005-.069.008v8.567c0 .002.075.006.07.008 1.683-.663 2.949-2.333 2.952-4.292-.003-1.959-1.269-3.63-2.953-4.291z",
    fill: "#2980B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.622 21.443a7.224 7.224 0 01-4.614 1.657 7.22 7.22 0 01-4.612-1.657 7.24 7.24 0 01-2.64-5.597 7.236 7.236 0 012.914-5.813 7.252 7.252 0 011.195-.725 7.225 7.225 0 013.144-.716 7.227 7.227 0 015.368 2.377 7.296 7.296 0 011.314 2.054c.367.867.57 1.821.57 2.823a7.24 7.24 0 01-2.639 5.597zM17.72 8H13.99C9.608 8 6 11.203 6 15.928c0 4.324 3.608 7.932 7.991 7.791h3.728c4.33.14 8.284-3.468 8.284-7.79C26.003 11.201 22.05 8 17.72 8z",
    fill: "#2980B9"
  }));
};

SvgDiners.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgDiners.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgDiners;